import React, { useEffect, useState } from "react";
import SubHeader from "../../layout/components/SubHeader";
import TreeView from "./TreeView";
import ArticlesHeader from "./ArticlesHeader";
import ArticlesList from "./ArticlesList";
import { useEyeconxStore } from "../../../store/eyeconxStore";
import articlesService from "../../../services/articles.service";
import Loading from "../../common/Loading";

function Articles() {
  const user = useEyeconxStore((state) => state.user);
  const [catLoading, setCatLoading] = useState(false);
  const [categoriesList, setCategoriesList] = useState([]);
  const [articlesList, setArticlesList] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumbers, setPageNumbers] = useState([]);
  const [sortBy, setSortBy] = useState("lastModified");
  const [sortOrder, setSortOrder] = useState("asc");
  const [subHeadText, setSubHeadText] = useState("Powered by Eyeconx");
  const [cardHeadText, setCardHeadText] = useState("Latest");
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearching,setIsSearching] = useState(false)
  const [categoryId,setCategoryId] = useState(0)
  const [categoryTitle,setCategoryTitle] = useState(null)
  //const pageNumbers = [];


  useEffect(() => {
    getCategories();
    getArticles(currentPage, itemsPerPage, sortBy, sortOrder);
  }, [currentPage, sortBy, sortOrder]);

  const getCategories = () => {
    setCatLoading(true);
    articlesService
      .getCategories(user.clinicId)
      .then((res) => {
        setCategoriesList(res.data);
        setCatLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setCatLoading(false);
      });
  };
 const updateSelectedCategory = (catergory_id,catergory_title) =>{
     console.log("Update Selected Category:"+catergory_id)
    setCategoryId(catergory_id)
    setCategoryTitle(catergory_title)
     setCardHeadText("Articles in "+catergory_title)
    getArticles(currentPage, itemsPerPage, sortBy, sortOrder,catergory_id);
 }
 const getLatestArticles = () =>{
     console.log("Get Latest Articles")
     setCardHeadText("Latest")
     getArticles(currentPage, itemsPerPage, sortBy, sortOrder);
 }
  const getArticles = (current_page, items_per_page, sort_by, sort_order,cat_id=0) => {
    //reset pageNumber to empty array
    //console.log("Get Articles")
    //console.log("Sort by: "+sort_by+" Sort order: "+sort_order)
    articlesService
      .getArticles(
        user.clinicId,
        current_page,
        items_per_page,
        sort_by,
        sort_order,
        cat_id
      )
      .then((res) => {
        setArticlesList(res.data.content);
        //console.log(res.data.content)
        // setCurrentPage(res.data.number+1)
        setTotalPages(res.data.totalPages);
        //pageNumbers.length = 0;
        setPageNumbers([]);
        for (let i = 1; i <= res.data.totalPages; i++) {
          //pageNumbers.push(i)
          setPageNumbers((prevState) => [...prevState, i]);
        }
        setSubHeadText(
          "Powered by Eyeconx | Total Articles : " + res.data.totalElements
        );
        //console.log("Page Numbers in Articles ")
        //console.log(pageNumbers)
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const handleSortChange = (sby, sorder) => {
    console.log("Sort by: " + sby + " Sort order: " + sorder);
    setSortBy(sby);
    setSortOrder(sorder);
  };

  const handleSearchArticle = (searchText) => {
    articlesService
      .searchArticle(user.clinicId, searchText)
      .then((res) => {
        setArticlesList(res.data.content);
        setTotalPages(res.data.totalPages);
        //pageNumbers.length = 0;
        setPageNumbers([]);
        for (let i = 1; i <= res.data.totalPages; i++) {
          //pageNumbers.push(i)
          setPageNumbers((prevState) => [...prevState, i]);
        }
        setSearchTerm(searchText);
        setCardHeadText("Search Results for : " + searchText);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleClearSearchTerm = () => {
    setSearchTerm("");
    setCardHeadText("Latest");
    getArticles(currentPage, itemsPerPage, sortBy, sortOrder);
  };
  const updateSearchTerm = (searchText) => setSearchTerm(searchText);
  return (
    <>
      <ArticlesHeader
        subHeadingText={subHeadText}
        handleSortChange={handleSortChange}
        handleSearchArticles={handleSearchArticle}
        searchTerm={searchTerm}
        updateSearchTerm={updateSearchTerm}
        handleClearSearchTerm={handleClearSearchTerm}
      />
      <div className="app-container container-xxl mt-3">
        <div className="row">
          <div className="col-md-3">

                {catLoading ? (
                  <>
                    <Loading />
                  </>
                ) : (
                  <TreeView
                        categories={categoriesList}
                        updateSelectedCategory={updateSelectedCategory}
                        getLatestArticles = {getLatestArticles}
                  />
                )}

          </div>
          <div className="col-md-9 pt-md-0 pt-3">
            <div className="card">
              <div className="card-body">
                <ArticlesList
                  articlesList={articlesList}
                  itemsPerPage={itemsPerPage}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  paginate={paginate}
                  pageNumbers={pageNumbers}
                  headingText={cardHeadText}
                  searchTerm={searchTerm}
                 
                  handleClearSearchTerm={handleClearSearchTerm}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Articles;
